import map from 'ramda/es/map';
import filter from 'ramda/es/filter';

import { APPS2_SUCCESS } from 'app/actions/apps/apps';
import { SUB_STOP_SUCCESS } from 'app/actions/apps/subs';
// import { APP_SUBSCRIBE_SUCCESS } from 'app/actions/apps/subscribe';

const defaultState = {
  // данные приложений, распределенные по символьным именам
  // для приложений с подписками id_студента => id_подписки
  // сами подписки в соседнем редюсере
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case APPS2_SUCCESS: {
      return action.payload.apps;
    }

    case SUB_STOP_SUCCESS: {
      return map((value) => {
        return filter((subId) => {
          return !action.payload.ids.includes(subId);
        }, value);
      }, state);
    }

    // case APP_SUBSCRIBE_SUCCESS: {
    //   return merge({}, state, action.payload.data);
    // }

    default:
  }

  return state;
}
